import { KeyValue } from '@/main/models/common';
import { QuoteStatusTypes, QuoteStatusActionTypes } from './quoteStatusTypes';

export function getQuoteStatus(
  isUserControl?: boolean | null
): QuoteStatusActionTypes {
  return {
    type: QuoteStatusTypes.GET_QUOTE_STATUS,
    payload: { isUserControl: isUserControl ?? null }
  };
}

export function saveQuoteStatus(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null, 
  keyReducer: string = 'default'
): QuoteStatusActionTypes {
  return {
    type: QuoteStatusTypes.SAVE_QUOTE_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerQuoteStatus(): QuoteStatusActionTypes {
  return {
    type: QuoteStatusTypes.RESET_REDUCER_QUOTE_STATUS
  };
}

export function getDomainQuoteStatus(keyReducer: string = 'default'): QuoteStatusActionTypes {
  return {
    type: QuoteStatusTypes.GET_DOMAIN_QUOTE_STATUS,
    payload: { 
      keyReducer 
    }
  };
}
